module.exports = __webpack_public_path__ + "da179bac3c76bac8b6662678dc68ffd9.svg";